import { Component } from 'react'
import ReactDOM from 'react-dom'

/**
 * Mounts children into `#portal`, the sibling of `#root`.
 *
 * Overlays have to leave the markup they are triggered from. Every rounded card carries a
 * `backdrop-filter`, which makes the card a stacking context and the containing block for fixed
 * descendants, so an overlay left inside one is both clipped to that card's layer and positioned
 * against the card rather than the viewport. See `constants/z-index` for the layers out here.
 */

// Resolved on mount rather than at import: tests render without the host page's #portal node, and
// document.body holds overlays just as well.
const getPortalRoot = () => document.getElementById('portal') ?? document.body

class Portal extends Component {
  constructor(props) {
    super(props)
    this.el = document.createElement('div')
  }

  componentDidMount() {
    getPortalRoot().appendChild(this.el)
  }

  componentWillUnmount() {
    this.el.remove()
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el)
  }
}

export default Portal
